import { Users } from '@platform/client';
import { GetCurrentUser200 } from '@platform/client/schemas';
import NextBestActions from '../next-best-actions';
import NextStepsSegment from './NextSteps/NextStepsSegment';
import BusinessChallengesSection from '../business-challenges';
import { RejoinPanel } from './RejoinPanel';
import { isCorporateProNoCohort, isInactiveUser } from '../../util/ProgramHelpers';
// import { IndividualInactivePanel } from './IndividualInactiveUserPanel';
import { userApplicationApproved } from '../../app';

/** The main content panel of the dashboard home page */
const DashboardHomePanel = () => {
  const { isSuccess, data: user } = Users.useGetCurrentUser({
    query: {
      // Throw an error if we fail to fetch user data after retries are complete
      // TODO: Find a more graceful way to error the frontend when we are unable to fetch core app data like this, outside of the Dashboard feature
      throwOnError: true,
    },
  });
  const isInactiveProfessional = isInactiveUser(user);
  // Non corporate inactive users is scheduled for release June 2026. In the meantime, we only show the rejoin panel to corporate inactive users.
  const hasDashboardAccess =
    userApplicationApproved(user) &&
    (!user?.corporatePartner || (!isInactiveProfessional && !isCorporateProNoCohort(user)));

  return (
    <div className='px-4 sm:pl-11 w-full md:w-[870px] min-w-0 flex flex-col gap-4'>
      <div className='flex flex-col gap-4'>
        <div className='text-3xl'>Welcome back{isSuccess && `, ${user?.firstName}`}</div>
        {hasDashboardAccess && (
          <>
            {isSuccess && <NextBestActions user={user as GetCurrentUser200} />}
            {user?.accountType === 'organization' && user?.organization?.id && (
              <BusinessChallengesSection organizationId={user.organization.id} />
            )}
            <NextStepsSegment />
          </>
        )}
        {!hasDashboardAccess && user?.corporatePartner && <RejoinPanel user={user} />}
        {/* See above comment - this is pending 'Share your perspective' form/feature */}
        {/* {!hasDashboardAccess && !user?.corporatePartner && <IndividualInactivePanel />} */}
      </div>
    </div>
  );
};

export default DashboardHomePanel;
